app.service('modalService', ['$rootScope', '$timeout', '$filter', function ($rootScope, $timeout, $filter) {

	$rootScope.modal = {
		icon : null,
		title : null,
		description : null,
		listArr: [],
		loader: false,
		active : false
	};

	$rootScope.$watch('modal.active', function(newValue) {
		if(newValue) {
			$timeout(function() {
				$('#main-modal').modal({
					onHidden : function() {
						$rootScope.modal.active = false;
					}
				}).modal('show');
			});
		}
	});

	return {
		show: function(icon, title, description, listArr, loader) {
			$timeout(function() {
				$rootScope.modal = {
					icon : icon,
					title : title,
					description : description,
					listArr: (listArr === null || listArr === undefined) ? [] : listArr,
					loader : (loader !== undefined && loader !== null && loader !== false),
					active : true
				};
			});
		},
		file: function() {
			this.show('file', $filter('translate')('fichier_non_trouve'));
		},
		loader: function(title) {
			this.show(null, title, null, [], true);
		},
		close: function() {
			$('#main-modal').modal('hide');
		}
	}
}]);
